import { render, staticRenderFns } from "./trades.vue?vue&type=template&id=01163975&scoped=true&"
import script from "./trades.vue?vue&type=script&lang=js&"
export * from "./trades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01163975",
  null
  
)

export default component.exports